export class User {
    constructor(
        public id = '',
        public accountId = '',
        public accountArt = '',
        public mitarbeiterid = '',
        public email = '',
        public art = '',
        public name = '',
        public disabled = false,
    ) {}
}

export class NewsFeedEntry {
    constructor(
        public id = '',
        public type: 'update' | 'general' = 'general',
        public prio = 0,
        public topic = '', // Title
        public info = '', // Text / Desc // Markdown! only if no HTML
        public html = '', // Text / Desc // HTML!
        public attachments: Array<string> = [], // Array of Downloadurls
        public createdBy = '',
        public createdAt = '',
        public createdAtUnix: number = 0,
        public visibleFromIso = '',
        public visibleFromUnix: number = 0,
        public visible = false,
        public disabled = false,
    ) {}
}

export class FeatureRequest {
    constructor(
        public id = '',
        public featureRequestNo = 0,
        public clientType: 'kul' | 'basis' | 'delle' = 'kul',
        public clientGroup: 'prc' | 'qwerk' | '' = '',
        public type = '', // type of Reqeust
        public topic = '', // Title
        public info = '', // Text / Desc // Markdown!
        public attachments: Array<string> = [], // Array of Downloadurls
        public clientAccountId = '',
        public clientName = '',
        public createdBy = '',
        public createdAt = '',
        public createdAtUnix: number = 0,
        public updatedBy = '',
        public updatedAt = '',
        public updatedAtUnix = 0,
        public votes = 0,
        public visibleForAll = false,
        public status: 'created' | 'refused' | 'inDiscussion' | 'planned' | 'inDevelopment' | 'released' = 'created',
        public deleted = false,
    ) {}
}

export class TrelloCard {
    constructor(
        public id = '',
        public trelloId = '',
        public ticketId = '',
        public name = '',
        public desc = '',
        public due = '',
        public dateLastActivity = '',
        public trelloBoardId = '',
        public trelloListId = '',
        public trelloListName = '',
        public shortUrl = '',
        public url = '',
        public lastSync = '',
        public trelloHookId = '',
        public closed = false,
        public deleted = false,
        public synced = false,
        public dueComplete = false,
        public lastUpdateFromBackend = false,
        public customFields: any = {},
        public labels: any[] = [],
        public attachments: any[] = [],
    ) {}
}

// deleted -> not visible for all
// clientAccountId -> always visivle
// !clientAccountId
// visible if visibleForAll

export class Comment {
    constructor(
        public id = '',
        public parentType: 'ticket' | 'featureRequest' = 'ticket', // Ticket or FeatureRequest
        public parentId = '', // Ticket or FeatureRequest
        public parentCommentId = '',
        public clientAccount = '',
        public text = '', // Text / Desc // Markdown!
        public attachments: Array<string> = [], // Array of Downloadurls
        public createdBy = '',
        public createdByName = '',
        public createdAt = '',
        public createdAtUnix: number = 0,
        public editedAt = '',
        public edits: Array<{ unix: number; text: string }> = [],
        public createdBySupport = false,
        public deleted = false,
    ) {}
}

export class Ticket {
    constructor(
        public type: 'support' | 'lead' | 'general' | 'client' = 'support',
        public color: 'green' | 'blue' | 'red' | 'orange' | '' = '',
        public kategorie: 'sonstiges' | 'feature' | 'bug' | '' = '',
        public level: number = 1,
        public medium: 'call' | 'mail' | 'portal' = 'call',
        public ticketNo = 0,
        public ticketId = '',
        public trelloCardId = '',
        public knowledgeId = '',
        public callId = '',
        public leadId = '',
        public clientId = '', // PDR Account Id
        public clientUserId = '',
        public clientUserName = '',
        public topic = '', // Title
        public info = '', // Text / Desc
        public clientInfo = '', // Text / Desc
        public answer = '', // Text / Desc

        public dueAt = '',

        public doneAt = '',
        public doneAtUnix = 0,
        public doneBy = '',
        public done = false,
        public bookmarked = false,

        public updatedBy = '',
        public updatedAt = '',
        public updatedAtUnix = 0,
        public clientToLeadAtUnix = 0,
        public reScheduledFor = 0,
        public createdBy = '', // Uid
        public assignedTo = '', // Uid
        public assignedBy = '',
        public assignedAt = '',
        public assignedAtUnix = 0,
        public prio = 0,
        public createdAt = '',
        public jiraId = '',
        public jiraKey = '',
        public jiraStatusName = '',
        public jiraSyncedAt = 0,
        public createdAtUnix: number = 0,
        public updatedBySupportAtUnix: number = 0,
        public lastAnswerAtUnix: number = 0,
        public lastAnswerBy: 'client' | 'support' = 'support',
        public lastAnswerBySupportAtUnix: number = 0,
        public lastAnswerByClientAtUnix: number = 0,

        public attachments: Array<string> = [], // Array of Downloadurls
    ) {}
}

export class ClientTicket {
    constructor(
        public ticketNo = 0,
        public ticketId = '',
        public knowledgeId = '',
        public clientId = '', // PDR Account Id
        public clientUserId = '',
        public clientUserName = '',
        public topic = '', // Title
        public clientInfo = '', // Text / Desc
        public answer = '', // Text / Desc
        public doneAt = '',
        public doneAtUnix = 0,
        public doneBy = '',
        public done = false,
        public updatedBy = '',
        public updatedAt = '',
        public updatedAtUnix = 0,
        public createdBy = '', // Uid
        public createdAt = '',
        public createdAtUnix: number = 0,
        public lastAnswerAtUnix: number = 0,
        public lastAnswerBy: 'client' | 'support' = 'client',
        public attachments: Array<string> = [], // Array of Downloadurls
    ) {}
}

export class Lead {
    constructor(
        public leadId = '',
        public leadAssignedTo = '',
        public clientId = '',
        public leadType: 'basis' | 'kul' | 'misc' | '' = '',
        public scourceType: 'kunde' | 'DAT' | 'socialmedia' | 'Kaltakquise' | '' = '',
        public scourceId = '',
        public scourceInfo = '',
        public clientType: 'kulm' | 'kul' | 'delle' | 'mechanik' | 'aufbereiter' | '' = '',
        public color: 'green' | 'blue' | 'red' | 'orange' | '' = '',
        public country: 'DE' | 'AT' | 'CH' | '' = '',
        public clientSize: number = 0,
        public fromDms = '',
        public fromKalk = '',
        public aktKalk = '',
        public leadAt = '',
        public leadAtUnix: number = 0,
        public website = '',
        public ansprechpartner = '',
        public name = '',
        public email = '',
        public strasse = '',
        public plz = '',
        public ort = '',
        public tel = '',
        public extraPhones: string[] = [],
        public telPartials: string[] = [],
        public allPhones: string[] = [],
        public steuerer: string[] = [],
        public mobil = '',
        public info = '',
        public createdBy = '',
        public createdAt = '',
        public createdAtUnix: number = 0,
        public initalBookingAtUnix: number = 0,
        public leadClosedBy = '',
        public leadClosedAt = '',
        public leadClosedAtUnix: number = 0,
        public leadClosed = false,
        public leadActiv = true,
        public reScheduledFor = '',
        public assignedTo = '', // Uid
        public assignedBy = '',
        public assignedAt = '',
        public geocode = false,
        public geoError = false,
        public lat = 0,
        public lng = 0,
        public assignedAtUnix = 0,
        public deleted = false,
    ) {}
}

export class LeadSource {
    constructor(
        public scourceId = '',
        public scourceType: 'intern' | 'DAT' | 'socialmedia' = 'intern',
        public name = '',
    ) {}
}

export class LoggedUpdate {
    constructor(
        public dataId = '',
        public dataType = '',
        public updatedBy = '',
        public updatedAt = '',
        public updatedAtUnix = 0,
        public from: any,
        public to: any,
    ) {}
}
export class Client extends Lead {
    constructor(
        public clientGroup = '',
        public clientAssignedTo = '',
        public toDms = '',
        public booked = false,
        public bookingActiv = false,
        public rechnungOffen = false,
        public canceled = false,
        public canceledAt = false,
        public canceledAtUnix = false,
        public testLizenz = '', // Datum bis
        public freieLizenz = false, // Wert für Entwickerlizenzen
        public enterprise = false,
        public allowCreditcard = false,
        public einrichtungBerechnet = false,
        public smsGuthaben = 0,
        public activeEmployees = 0,
        public stripeCustomerId = '',
        public groupId = '',
        public datenschutz: any = {},
        public refcode = '',
        public lizenz: Lizenz | null = null,
        public paid_basis = 0,
        public paid_benutzer = 0,
        public paid_benutzer_quantity = 0,
        public paid_multi = 0,
        public paid_planer = 0,
        public paid_kul5 = 0,
        public paid_kul10 = 0,
        public paid_kul15 = 0,
        public paid_kul20 = 0,
        public paid_kul30 = 0,
        public paid_kul40 = 0,
        public paid_kul60 = 0,
        public paid_kul50 = 0,
        public paid_kul75 = 0,
        public paid_kul99 = 0,
        public paid_kul = 0,
        public paid_kulUsers = 0,
        public paid_leihwagen = 0,
        public paid_win = 0,
        public initalBookingAt = '',
        public initalBookingAtUnix = 0,
        public hukAktiv = false,
        public audatex = false,
        public igAktiv = false,
        public smartDocsActive = false,
        public manualPayment = false,
        public aktiveBenutzer: number = 0, // summe der Benutzer unter listOfUsers, gepflegt durch function
    ) {
        super();
    }
}
export class Lizenz {
    constructor(
        public graph = false,
        public dellen = false,
        public dellenat = false,
        public dellench = false,
        public dellenAnfragen = false,
        public multiUser = false,
        public planer = false,
        public mietwagen = false,
        public autex = false,
        public beta = false,
        public mussBeta = false,
        public logik = false,
        public sfk = false,
        public adi = false,
        public win = false,
        public winKL = false,
        public rechnung = false,
        public personal = false,
        public kapa = false,
        public werkplan = false,
        public terminierung = false,
        public prc = false,
    ) {}
}

export class Account {
    // 'multi', 'planer', 'leihwagen', 'win'
    constructor(
        public testLizenz = '', // Datum bis
        public freieLizenz = false, // Wert für Entwickerlizenzen
        public enterprise = false,
        public manualPayment = false,
        public allowCreditcard = false,
        public einrichtungBerechnet = false,
        public smsGuthaben = 0,
        public stripeCustomerId = '',
        public createdBy = '',
        public groupId = '',
        public refcode = '',
        public tenantId = '',
        public lockMessage = '',
        public paid_basis = 0,
        public paid_benutzer = 0,
        public paid_benutzer_quantity = 0,
        public paid_multi = 0,
        public paid_planer = 0,
        public paid_kul10 = 0,
        public paid_kul15 = 0,
        public paid_kul20 = 0,
        public paid_kul30 = 0,
        public paid_kul40 = 0,
        public paid_kul50 = 0,
        public paid_kul75 = 0,
        public paid_kul99 = 0,
        public paid_kul = 0,
        public paid_kulUsers = 0,
        public paid_leihwagen = 0,
        public paid_win = 0,
        public initalBookingAt = '',
        public initalBookingAtUnix = 0,
        public aktiveBenutzer: number = 0, // summe der Benutzer unter listOfUsers, gepflegt durch function
    ) {}
}
export class AccountMitId extends Account {
    constructor(public id = '') {
        super();
    }
}
